var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrap",class:_vm.$style.wrap},[(_vm.purecss)?_c('div',{staticClass:"icon",style:(_vm.genStyle)}):_c('object',{class:_vm.$style.iconob,attrs:{"type":"image/svg+xml","data":_vm.database64}})])}
var staticRenderFns = []

export { render, staticRenderFns }